const processInclude = require('./util');
const dataLayer = require('./dataLayer/dataLayer');

$(document).ready(() => {
    processInclude(require('./pdpVariationInitializer'));
    processInclude(require('./product/detail'));
    processInclude(require('./product/pdpInstoreInventory'));
    processInclude(require('./product/tabs'));
    processInclude(dataLayer.babyRegistryEvent);
    processInclude(dataLayer.pushProductDetail);
    processInclude(require('./components/forms/Spinbutton'));
});
